import styled from '@emotion/styled';
import { LabelText } from '../components';
import { Container as CheckboxContainer } from '../inputs/Checkbox';

const InputsContainer = styled.div`
  margin: 38px 0;
  ${LabelText} {
    margin-top: 32px;
  }
  ${CheckboxContainer}{
    margin: 10px 0;
  }
`;

export default InputsContainer;
